import { TextInput } from '@soteria/design-system-ve';

import { ClearButton } from './ClearButton';
import * as styles from './ImageUrlInputCard.css';

interface ImageUrlInputCardProps {
  imageUrl: string;
  hasError: boolean;
  onUrlChange: (value: string) => void;
  onFocus?: () => void;
  onClear: () => void;
}

/**
 * Image URL Input Card for entering image URLs
 * Simple input field - error handling and preview are done in ImageContentRenderer
 */
export function ImageUrlInputCard({ imageUrl, hasError, onUrlChange, onFocus, onClear }: ImageUrlInputCardProps) {
  return (
    <div className={styles.imageUrlInputContainer}>
      <TextInput hasError={hasError} placeholder="Paste an image URL" type="text" value={imageUrl} onChange={onUrlChange} onFocus={onFocus} />
      {imageUrl && <ClearButton ariaLabel="Clear image URL input" title="Clear URL" onClick={onClear} />}
    </div>
  );
}
